// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: bcSfFilterConfig.custom.products_per_page
     
    
    }
}; 

// Declare Templates
var bcSfFilterTemplate = {
    'soldOutClass': 'sold-out',
    'saleClass': 'on-sale',
    'soldOutLabelHtml': '<div>' + bcSfFilterConfig.label.sold_out + '</div>',
    'saleLabelHtml': '<div>' + bcSfFilterConfig.label.sale + '</div>',
    'vendorHtml': '{{itemVendorLabel}}',
  'productGridItemHtml': '<div data-id="{{itemId}}" class="collection-product-border collection-product site-box box--small box--typo-small lap--box--small-lg box--center-align box--no-padding box--column-flow box__collection active active" data-order="{{dataOrder}}">' +
        '<div class="site-box-content">' +
        '<a href="{{itemUrl}}" class="product-item style--one alt color--light">' +
        '<div class="box--product-image primary">' +
        '<img src="{{itemThumb}}" alt="{{itemTitle}}" srcset="{{itemThumbUrl}} 360w, {{itemThumb}} 480w, {{itemThumbMediumUrl}} 960w" data-srcset="{{itemThumbUrl}} 360w, {{itemThumb}} 480w, {{itemThumbMediumUrl}} 960w" data-sizes="auto" class="lazyload">' +
        '<noscript><span class="ll-fallback" style="background-image:url({{itemThumbMediumUrl}})"></span></noscript>' +
        '</div>' +
        '{{itemBadge}}' +
        '<div class="caption">' +
        '<div>' +
        '<div class="product-item__name">' +
  		'<span class="product-item__vendor">{{itemVendor}}</span>' +
        '<h3><span style="font-weight:normal!important;" class="overflowed">{{itemTitle}}</span></h3>' +
        '</div>' +
        '<span class="product-item__price price abcd">{{itemPrice}}'+ //<span class="overflowed">' +
  		'<span class="new-price"> {{itemOldPrice}}</span>' +
        '</span>' +//</span>' +
        '{{itemKlub}}' +
        '{{itemKlubOffer}}' +
        '{{itemQtyMessage}}' +
        '<span aria-hidden="true">' +
        '<span class="longarrow"><span class="overflowed"><svg version="1.1" class="svg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 41 10" style="enable-background:new 0 0 41 10; width: 41px; height: 10px;" xml:space="preserve"><polygon points="0,4 35,4 35,0 41,5 35,10 35,6 0,6 "></polygon></svg></span></span>' +
        '</span>' +
        '</div>' +
        '</div>' +
        '</a>' +
        '</div>' +
        '</div>',

    // Pagination Template
    'previousActiveHtml': '<li class="prev"><a href="{{itemUrl}}"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 31 10" style="enable-background:new 0 0 31 10; width: 31px; height: 10px;" xml:space="preserve"><polygon points="31,5 25,0 25,4 0,4 0,6 25,6 25,10 "></polygon></svg></a></li>',
    'previousDisabledHtml': '',
    'nextActiveHtml': '<li class="next"><a href="{{itemUrl}}"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 31 10" style="enable-background:new 0 0 31 10; width: 31px; height: 10px;" xml:space="preserve"><polygon points="31,5 25,0 25,4 0,4 0,6 25,6 25,10 "></polygon></svg></a></li>',
    'nextDisabledHtml': '',
    'pageItemHtml': '<li class="page"><a href="{{itemUrl}}">{{itemTitle}}</a></li>',
    'pageItemSelectedHtml': '<li class="page current"><span class="active">{{itemTitle}}</span></li>',
    'pageItemRemainHtml': '<li><span>{{itemTitle}}</span></li>',
    'paginateHtml': '<ul class="pagination">{{previous}}{{pageItems}}{{next}}</ul>',

    // Sorting Template
    'sortingHtml': '<label for="bc-sf-filter-top-sorting-select" class="label--hidden">' + bcSfFilterConfig.label.sorting + '</label><select id="bc-sf-filter-top-sorting-select" class="collection-sort__input">{{sortingItems}}</select>',
};

/************************** BUILD PRODUCT LIST **************************/

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function (data, index) {

    if (parseInt(this.queryParams.page) === 1) {
        $('body').addClass('pagination-1');
    } else {
        $('body').removeClass('pagination-1');
    }

    /*** Prepare data ***/
    var images = data.images_info,
        soldOut = !data.available, // Check a product is out of stock
        firstVariant = data['variants'][0];

    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function (e) {
            return e.id == getParam('variant');
        });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }
    /*** End Prepare data ***/

        // Get Template
    var itemHtml = bcSfFilterTemplate.productGridItemHtml;


    //  Replace Data Order
    itemHtml = itemHtml.replace(/{{dataOrder}}/g, index);


    // Add Price
    var itemPrice = '';
    var oldPrice = '';
    var itemPriceHtml = '';
    var oldPriceHtml = '';

 // If there are variant prices
    if (data.price_min !== data.price_max) {
        // If on sale
        if (data.compare_at_price_min > data.price_min) {

            itemPrice += bcSfFilterConfig.label.sale_from_price.replace(/{{ price }}/g, this.formatPrice(data.price_min));
            oldPrice = '<span class="old-price">' + this.formatPrice(data.compare_at_price_min) + '</span>';
        } else {
            itemPrice += bcSfFilterConfig.label.from_price.replace(/{{ price }}/g, this.formatPrice(data.price_min));
        }
    } else {
        // If on sale
      //console.log(data);
        if (data.compare_at_price_min > data.price_min) {
            itemPrice += this.formatPrice(data.price_min);
            oldPrice = ' <span class="old-price nn">' + this.formatPrice(data.compare_at_price_min) + '</span>';
        } else {
            itemPrice += this.formatPrice(data.price_min);
        }
    }
  if(data.template_suffix == 'enquiry'){
    itemPrice = 'from '+itemPrice.replace('from','');
  }


    // Add product qty message
    var itemQtyHtml = '',
        productQuantity;

    if (data.variants.length >= 1) {

        productQuantity = 0;
        data.variants.forEach(function (variant) {
            if (variant.inventory_quantity > 0) {
                productQuantity = parseInt(productQuantity + variant.inventory_quantity);
            }
        });
    }

    // Add soldOut class
    var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
    itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);


    // Add soldOut Label
    var itemSoldOutLabelHtml = soldOut ? bcSfFilterTemplate.soldOutLabelHtml : '';
    itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabelHtml);


    // Add Badges
    var tags = data.tags,
        itemBadgeHtml = '';
		itemDiscountHtml = '';

    let isBadgeEmpty = true;


    if (tags.includes("4for3")) {
        isBadgeEmpty = false;
        itemBadgeHtml = '<div class="product-badge 4for3"><span>4for3</span></div>';
    } else if (tags.includes("6for4")) {
        isBadgeEmpty = false;
        itemBadgeHtml = '<div class="product-badge 6for4"><span>6for4</span></div>'
    } else if (tags.includes("3for2")) {
        isBadgeEmpty = false;
        itemBadgeHtml = '<div class="product-badge 3for2"><span>3for2</span></div>'
    } else if (data.percent_sale_min > 0) {
        isBadgeEmpty = false;
        var discountPercent = data.percent_sale_min;
      
                let maxDiscount = 0;

                if (data.variants.length >= 1) {
                    data.variants.forEach(function (variant) {
                        let discountPercentVariant = (variant.compare_at_price - variant.price) * 100;
                            discountPercentVariant = parseInt(discountPercentVariant / variant.compare_at_price);

                        if(discountPercentVariant > maxDiscount){
                            maxDiscount = discountPercentVariant;
                        }else{
                            maxDiscount = maxDiscount + 0;
                        }

                    });
                }
        if (discountPercent % 10 === 0 || discountPercent % 10 === 5) {

            // If value is klub
            if (window.klub && window.startTimes[data.id]) {
                isBadgeEmpty = false;
                itemBadgeHtml = '<div class="product-badge sale"><span>Klub</span></div>'
            } else {
                isBadgeEmpty = false;

                if(maxDiscount > discountPercent){
                    isBadgeEmpty = false;
                    itemBadgeHtml = '<div class="product-badge sale"><span>' + maxDiscount + '%</span></div>'
					itemDiscountHtml = maxDiscount;
                }else{
                    isBadgeEmpty = false;
                    itemBadgeHtml = '<div class="product-badge sale"><span>' + discountPercent + '%</span></div>'
					itemDiscountHtml = discountPercent;
                }

            }
        } else {

            // If value is klub
            if (window.klub && window.startTimes[data.id]) {
                isBadgeEmpty = false;
                itemBadgeHtml = '<div class="product-badge sale"><span>Klub</span></div>'
            } else {
                isBadgeEmpty = false;
                itemBadgeHtml = '<div class="product-badge sale"><span>Sale</span></div>';
            }

        }
    } else if (tags.includes("preorder")) {
        isBadgeEmpty = false;
        itemBadgeHtml = '<div class="product-badge preorder"><span>Preorder</span></div>'

    } else if (tags.includes("new")) {
        isBadgeEmpty = false;
        itemBadgeHtml = '<div class="product-badge new"><span>New</span></div>'
    }
    tags.forEach(function (item, index){
        if(item.indexOf('Badge:') >= 0){
            let t = item.replace('Badge:','');
            itemBadgeHtml = '<div class="product-badge special '+t+'"><span>'+t+'</span></div>';
            isBadgeEmpty = false;
        }
    })

    let seconds8    = 8 * 24 * 60 * 60;
    let seconds30   = 30 * 24 * 60 * 60;

    let dateStart = new Date(data.created_at);
        dateStart = dateStart.getTime() / 1000;

    let nowTimestamp = new Date();
        nowTimestamp = nowTimestamp.getTime() / 1000;

    let diffSeconds = nowTimestamp - dateStart;

    let diffDays = diffSeconds / 3600 / 24;

    if(isBadgeEmpty){
        if(diffDays < 8){
            //itemBadgeHtml = '<div class="product-badge new"><span>New this week!</span></div>'
        }
        if(diffDays > 7 && diffDays < 31){
            //itemBadgeHtml = '<div class="product-badge new"><span>New this month!</span></div>'
        }
    }


    itemHtml = itemHtml.replace(/{{itemBadge}}/g, itemBadgeHtml);


    // Add Vendor
    var itemVendorHtml = bcSfFilterTemplate.vendorHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);


    // Add Image
    var crop_img_url_small = '480x';
    var crop_img_url_regular = '600x';
    var crop_img_url_medium = '750x';
    var crop_img_url_large = '1440x';


    // Add Thumbnail
    itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, this.getFeaturedImage(images, crop_img_url_small));
    itemHtml = itemHtml.replace(/{{itemThumb}}/g, this.getFeaturedImage(images, crop_img_url_regular));
    itemHtml = itemHtml.replace(/{{itemThumbSmallUrl}}/g, this.getFeaturedImage(images, crop_img_url_small));
    itemHtml = itemHtml.replace(/{{itemThumbMediumUrl}}/g, this.getFeaturedImage(images, crop_img_url_medium));
    itemHtml = itemHtml.replace(/{{itemThumbLargeUrl}}/g, this.getFeaturedImage(images, crop_img_url_large));


    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));
	
  var CustomMemo = '';
  //var metafieldsa = JSON.parse(data.metafields);
  for(i=0;i<data.metafields.length;i++){
  	metafieldsa = data.metafields[i];
    if(metafieldsa['key'] == 'grid-meta-under-price'){
    	CustomMemo = metafieldsa['value'];
    }
  }
    var itemQtyHtml = '',
        itemQty = '';
  		itemQty = '<p class="stock-note">' + CustomMemo + '</p>';

    // Item Qty
//     if (productQuantity > 10) {
//         itemQty = '<p class="stock-note stock-note--in-stock">' + '10+ In stock / ready to ship</p>'
//     } else if (productQuantity > 0) {
//         itemQty = '<p class="stock-note stock-note--in-stock">' + productQuantity + ' In stock / ready to ship</p>'
//     } else {
//         if (window.klub && window.startTimes[data.id]) {
//             itemQty = '<p class="stock-note stock-note--out-of-stock">Sold Out</p>'
//         } else {
//             itemQty = '<p class="stock-note stock-note--out-of-stock">Available to order</p>'
//         }
//     }

    // Add Klub
    var klubHtml = '',
        klubOfferHtml = '';
  
  if (window.klub) {
    // Calculate Discount
        var klubDiscount = data.percent_sale_min > 0 ? data.percent_sale_min : false;
  if (klubDiscount) {
            klubHtml = '<div class="klub-product-live-message"><span class="klub-product-live-message--old">' + oldPrice +'</span><strong>' + itemPrice + '</strong> - KLUB OFFER - <strong>SAVE ' + klubDiscount + '%</strong></div>';
    
        } else {
            klubHtml = '<div class="klub-product-live-message"><span class="klub-product-live-message--old">' + oldPrice +'</span><strong>' + itemPrice + '</strong> - KLUB OFFER</div>';
          
        }
    $( ".product-item__price" ).remove();
  } else {

        itemQtyHtml = itemQty;
        itemPriceHtml = itemPrice;
        oldPriceHtml = oldPrice;
    };

    // If the category is a klub page
    if (window.klub) {

        var countDownDate = new Date(window.startTimes[data.id]);

        // Get today's date and time
        var now = new Date().getTime();

        // Find the distance between now and the count down date
        var distance = countDownDate.getTime() - now;

        let date = ("0" + countDownDate.getDate()).slice(-2) +'.' + ("0" + (countDownDate.getMonth() + 1)).slice(-2) + '.'+ ("0" + countDownDate.getFullYear()).slice(-2);
        var h = countDownDate.getHours(),
            m = countDownDate.getMinutes();

        var time = (h > 12) ? (h-12 + ':' + ("0" + m).slice(-2) +' PM') : (h + ':' + ("0" + m).slice(-2) +' AM');

        // Calculate Discount
        var klubDiscount = data.percent_sale_min > 0 ? data.percent_sale_min : false;


        


        // If the count down is finished, write some text
        

            // Campaign is live
            klubOfferHtml = '<div class="klub-product-offer-message live">OFFER LIVE NOW - ' + itemQty + '</div>';

        
    } 
  
  

    itemHtml = itemHtml.replace(/{{itemKlub}}/g, klubHtml);
    itemHtml = itemHtml.replace(/{{itemKlubOffer}}/g, klubOfferHtml);
    itemHtml = itemHtml.replace(/{{itemQtyMessage}}/g, itemQtyHtml);
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);
    itemHtml = itemHtml.replace(/{{itemOldPrice}}/g, oldPriceHtml);
	itemHtml = itemHtml.replace(/{{itemDiscount}}/g, itemDiscountHtml);
	


    return itemHtml;
};

BCSfFilter.prototype.formatPrice = function (price) {

    // Currently returning incorrect
    //this.formatMoney(data.price_min);

    // Work around
  	//return this.formatMoney(price*100, this.moneyFormat);
    return '£' + (price).toFixed(2);
};

// Customize data to suit the data of Shopify API
BCSfFilter.prototype.prepareProductData = function (data) {

    for (var k in data) {
        // Add Options
        var optionsArr = [];
        for (var i in data[k]['options_with_values']) {
            optionsArr.push(data[k]['options_with_values'][i]['name']);
        }
        data[k]['options'] = optionsArr;
		//console.log(data);
        // Customize variants
        for (var i in data[k]['variants']) {
            var variantOptionArr = [];
            var count = 1;
            var variant = data[k]['variants'][i];
            // Add Options
            var variantOptions = variant['merged_options'];
            if (Array.isArray(variantOptions)) {
                for (var j = 0; j < variantOptions.length; j++) {
                    var temp = variantOptions[j].split(':');
                    data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1];
                    data[k]['variants'][i]['option_' + temp[0]] = temp[1];
                    variantOptionArr.push(temp[1]);
                }
                data[k]['variants'][i]['options'] = variantOptionArr;
            }
            data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100;
            data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100;
        }

        // Add Description
        // data[k]['description'] = data[k]['body_html'];
    }
    return data;
};

/************************** END BUILD PRODUCT LIST **************************/

// Build Pagination
BCSfFilter.prototype.buildPagination = function (totalProduct) {
    if (this.getSettingValue('general.paginationType') == 'default') {
        // Get page info
        var currentPage = parseInt(this.queryParams.page);
        var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

        // If it has only one page, clear Pagination
        if (totalPage === 1) {
            jQ(this.selector.bottomPagination).html('');
            return false;
        }

        if (this.getSettingValue('general.paginationType') === 'default') {

            var paginationHtml = bcSfFilterTemplate.paginateHtml;

            // Build Previous
            var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
            previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
            paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

            // Build Next
            var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextDisabledHtml;
            nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
            paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

            // Create page items array
            var beforeCurrentPageArr = [];
            for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
                beforeCurrentPageArr.unshift(iBefore);
            }
            if (currentPage - 4 > 0) {
                beforeCurrentPageArr.unshift('...');
            }
            if (currentPage - 4 >= 0) {
                beforeCurrentPageArr.unshift(1);
            }

            // Hide and show collection images on pages
            var collectionImage = $('.collection-image');
            if (currentPage === 1) {
                $('body').addClass('pagination-1');
            } else {
                $('body').removeClass('pagination-1');
            }

            beforeCurrentPageArr.push(currentPage);

            var afterCurrentPageArr = [];
            for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
                afterCurrentPageArr.push(iAfter);
            }
            if (currentPage + 3 < totalPage) {
                afterCurrentPageArr.push('...');
            }
            if (currentPage + 3 <= totalPage) {
                afterCurrentPageArr.push(totalPage);
            }

            // Build page items
            var pageItemsHtml = '';
            var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
            for (var iPage = 0; iPage < pageArr.length; iPage++) {
                if (pageArr[iPage] == '...') {
                    pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
                } else {
                    pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
                }
                pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
                pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
            }
            paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

            jQ(this.selector.bottomPagination).html(paginationHtml);
        }
    }
};

/************************** BUILD TOOLBAR **************************/

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function () {
    if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
        jQ(this.selector.topSorting).html('');

        var sortingArr = this.getSortingList();
        if (sortingArr) {
            // Build content
            var sortingItemsHtml = '';
            for (var k in sortingArr) {
                sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
            }
            var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
            jQ(this.selector.topSorting).html(html);

            // Set current value
            jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
        }
    }
};

/************************** END BUILD TOOLBAR **************************/

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function (data, eventType) {
  // Call function to get extra product html by ajax
        this.buildExtrasProductListByAjax(data, 'boost-integration', function(results){
          results.forEach(function(result){
           // Append the custom html to product item
           jQ('[data-id="'+ result.id+ '"] .product-item__price').append(result.unit_price);
           //jQ('[data-product-id="'+ result.id+ '"] .grid-product__description').append(result.product_info);
          })
        })
};

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function (data, eventType) {
};

BCSfFilter.prototype.setSuggestionWidth = function (e, t) {
    var newHeight = ($('#site-search').height()) - 250;
    jQ("ul." + this.class.searchSuggestion + '[data-search-box="' + e + '"]').outerWidth(t);
    jQ("ul." + this.class.searchSuggestion + '[data-search-box="' + e + '"]').height(newHeight);
};

BCSfFilter.prototype.buildSuggestionMobile = function () {
};

BCSfFilter.prototype.openSuggestionMobile = function (e) {
};

BCSfFilter.prototype.showSearchBoxMobile = function (e) {
};

BCSfFilter.prototype.clickOutsideSuggestionMobileEvent = function () {
};

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
